<template>
    <div class="l-live-body">
        <img class="l-main-right" src="./../images/right.png" alt="">
        <div class="l-main-back">
            <img class="l-back-img" src="./../images/back.png" alt="" />
            <div class="l-back-button" @click="handleGoBack()"></div>
        </div>
        <div class="l-live-main">
            <div class="l-live-title">
                直播指导表现
            </div>
            <LSelect @changeYear="handleYear"></LSelect>
            <div class="l-live-content">
                <div class="l-live-list">
                    <div class="l-live-list-item" v-for="item in listData" :key="item.taskId"
                        @click="handleDetail(item)">
                        <div class="item-time">{{ item.title }}</div>
                        <div class="item-award">
                            <div class="item-score wen" v-for="(wen, wenIndex) in item.rewardWen" :key="wenIndex + 'wen'">
                                <div class="score-top">+{{ wen }}</div>
                                <div class="score-bottom"></div>
                            </div>
                            <div class="item-score wu" v-for="(wu, wuIndex) in item.rewardWu" :key="wuIndex + 'wu'">
                                <div class="score-top">+{{ wu }}</div>
                                <div class="score-bottom"></div>
                            </div>
                            <div class="item-score subtract" v-for="(subtract, subtractIndex) in item.punishment"
                                :key="subtractIndex">
                                <div class="score-top">{{ subtract }}</div>
                                <div class="score-bottom"></div>
                            </div>

                        </div>
                        <div v-if="([...item.rewardWen, ...item.rewardWu, ...item.punishment].length > 5)"
                            class="item-omit">...</div>
                        <div v-if="item.showRead">
                            <div v-if="item.live === '缺席'" class="item-icon absenteeism">{{ item.live }}</div>
                            <div v-else-if="item.live === '请假'" class="item-icon leave">{{ item.live }}</div>
                            <div v-else-if="(item.live === '出勤' && item.coin)" class="item-gold"> <img
                                    src="./images/l-coin.png" alt="">
                                <span>+{{ item.coin }}</span>
                            </div>
                            <div v-else class="item-gold"></div>
                        </div>
                        <div v-else class="item-read">
                            <img class="item-new" src="./images/new.png" />
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import LSelect from "@/views/record/live/components/l-select";
import TaskModel from './../models/task'
const taskModel = new TaskModel()
export default {
    name: 'liveList',
    data() {
        return {
            yearList: [
                "2022",
                "2021",
                "2022"
            ],
            listData: [
            ]
        }
    },
    components: {
        LSelect
    },
    mounted() {
        this.handleGetList(new Date().getFullYear())
    },
    methods: {
        handleGetList(date) {
            let params = {
                date: date
            }
            taskModel.getLiveList(params).then(res => {
                this.listData = res.data;
            })
        },
        handleChangeYear() {

        },
        handleGoBack() {
            this.$router.back()
        },
        handleYear(value) {
            this.handleGetList(value)
        },
        handleDetail(item) {
            if (!item.showRead) {
                taskModel.postLiveRead({ taskId: item.taskId })
            }
            this.$router.push({
                name: 'liveDetail',
                params: {
                    taskId: item.taskId,
                }
            })
        }
    }
}
</script>
<style scoped lang="stylus">
@import "./css/list.styl";
</style>